module.exports = __webpack_public_path__ + "52bf0561faa6356d0bc871cc23ab411f.png";